import { Component, OnInit, Output, EventEmitter } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-number-picker",
  templateUrl: "./number-picker.component.html",
  styleUrls: ["./number-picker.component.scss"],
})
export class NumberPickerComponent implements OnInit {
  @Output() change = new EventEmitter();

  count: number = 0;
  text: any;
  placeholder: string;
  private textDay: string;
  private textDays: string;

  constructor(private translate: TranslateService) {}

  ngOnInit() {
    this.textDay = this.translate.instant("numberPicker.day");
    this.textDays = this.translate.instant("numberPicker.days");
    this.placeholder = this.translate.instant("numberPicker.select");
  }

  addCount() {
    this.count = +this.count + 1;
    this.text =
      this.count === 1
        ? `${this.count} ${this.textDay}`
        : `${this.count} ${this.textDays}`;
    this.change.emit(this.count);
  }

  removeCount() {
    this.count = +this.count - 1;
    this.text =
      this.count === 1
        ? `${this.count} ${this.textDay}`
        : `${this.count} ${this.textDays}`;
    this.change.emit(this.count);
  }

  writeNumber(event) {
    if (
      (event.keyCode >= 48 && event.keyCode <= 57) ||
      event.keyCode === 8 ||
      (event.keyCode >= 96 && event.keyCode <= 105)
    ) {
      this.count = +this.text;

      console.log(this.count);
    } else {
      return false;
    }
  }

  inputClean() {
    if (this.text === null) {
      this.text = this.count;
    } else {
      this.text = +this.count;
    }
  }

  inputBlur() {
    this.text =
      this.count === 1
        ? `${this.count} ${this.textDay}`
        : `${this.count} ${this.textDays}`;
    this.change.emit(this.count);
  }
}
